import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { INVOICE_CODE } from "../apiRoutes";

const mutateUpdateInvoiceCode = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${INVOICE_CODE}${id}`, data);
};

const useUpdateInvoiceCodesMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateInvoiceCode,
    ...queryParams,
  });

export default useUpdateInvoiceCodesMutation;
